<template>
  <div>
    <div v-for="data in dataList">
      <div class="flexbetween">
        <div class="">
          <h1 v-html="changeTag(data.word)" class="dictionary-result-main-title"></h1>
          <p v-html="changeTag(data.pronunciation)" class="text-phonetic" />
        </div>
        <img v-if="data.alcRank.length != 0" :src="data.alcRank" class="img-svl" />
      </div>
      <p v-html="changeTag(data.variationData)" class="mb30" />
      <div v-for="partOfSpeech in data.partOfSpeeches" class="mb30">
        <p v-html="changeTag(partOfSpeech.partOfSpeech)" />
        <div v-for="linesData in partOfSpeech.linesData">
          <div v-for="lines in linesData" class="mb30">
            <p v-html="changeTag(lines.text)" class="bold font-large" />
            <div v-for="child in lines.lineChildren">
              <p v-html="changeTag(child.childText)" class="bold" />
              <p v-html="changeTag(child.examples.example)" class="ml20" />
              <div v-for="column in child.examples.columns" class="section-column">
                <img src="static/images/icon/png/dictionary_column.png" class="img-section-column" />
                <p v-html="changeTag(column.title)" class="title-section-column" />
                <p v-html="changeTag(column.content)" class="ml30" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixin/common';

export default {
  name: 'wordResult',
  props: {
    dataList: Array
  },
  mixins: [
    common
  ]
};
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// WordResult.vue?56b4d645